import { useSession } from '@faststore/sdk'
import { getSessionFavouriteStore } from 'src/components/sections/Store/utilities'
import { useStoreContext } from 'src/contexts/store-context'
import { useStoreAPI } from './useStoreAPI'

export const useSaveFavouriteStore = () => {
  const {
    saveFavouriteStore,
    savePickupPointDataInSession,
    setFavouriteStoreInSession,
    getSellerId,
  } = useStoreAPI()

  const { setFavouriteStore } = useStoreContext()
  const { person } = useSession()

  const handleSaveFavouriteStore = async ({
    id,
    name,
    postalCode,
    sellerId,
    vtexSellerId,
    geoCoordinates,
    address,
  }: any) => {
    const favouriteStore = {
      name: name,
      id: id,
      postalCode: postalCode,
      sellerId: sellerId,
      vtexSellerId: vtexSellerId,
      geoCoordinates: geoCoordinates,
      address,
    }

    const storeInSession = getSessionFavouriteStore()

    if (
      storeInSession?.id !== id ||
      (storeInSession?.sellerId &&
        !storeInSession?.vtexSellerId?.toLowerCase()?.includes('franchise'))
    ) {
      const seller =
        favouriteStore &&
        (favouriteStore?.sellerId ?? (await getSellerId(favouriteStore.id)))

      favouriteStore.sellerId = seller

      setFavouriteStore(favouriteStore)

      person?.email && saveFavouriteStore(person?.email, id)

      setFavouriteStoreInSession(favouriteStore)
      savePickupPointDataInSession(
        favouriteStore.id,
        favouriteStore.vtexSellerId ?? favouriteStore.sellerId
      )
    }
  }

  return { handleSaveFavouriteStore }
}
